enum HttpMethods {
  get,
  post,
  put,
  delete
};

export default HttpMethods;